import React, { useState } from "react";
import * as v from "valibot";
import { valibotResolver } from "@hookform/resolvers/valibot";
import styles from "./addCustomer.module.css";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Input } from "../common/input/Input";
import { useForm } from "react-hook-form";
import { CustomToast } from "../common/customToast/CustomToast";
import { useAddCustomerMutation } from "../../features/api/customers/customersApi";
const phoneRegex = /^\+([3-9][0-9]{1,2})[0-9]{6,12}$/;
const schema = v.object({
  email: v.optional(v.email()), // Optional but must be valid email if present
  phone: v.optional(v.regex(phoneRegex, "Invalid phone number")),
  address: v.pipe(
    v.string("Address is required"),
    v.minLength(3, "Address is required")
  ),
  deliveryAddress: v.pipe(
    v.string("Delivery address is required"),
    v.minLength(3, "Address is required")
  ),
  firstName: v.pipe(
    v.string("First name is required"),
    v.minLength(3, "First name is required")
  ),
  lastName: v.pipe(
    v.string("Last name is required"),
    v.minLength(3, "Last name is required")
  ),
  companyName: v.pipe(
    v.string("Company name is required"),
    v.minLength(3, "Company name is required")
  ),
  registrationNo: v.pipe(
    v.string("Registration no is required"),
    v.minLength(3, "Registration no is required")
  ),
});

export const AddCustomer = ({ onSuccess }) => {
  const [customer, setCustomer] = useState({
    phone: "",
    email: "",
    address: "",
    lastName: "",
    firstName: "",
    companyName: "",
    registrationNo: "",
    deliveryAddress: "",
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: customer,
    resolver: valibotResolver(schema),
  });

  const [addCustomer, { isLoading, isSuccess, isError, error }] =
    useAddCustomerMutation();
  const onSubmit = async (data) => {
    try {
      await addCustomer(data).unwrap();
      setTimeout(() => {
        onSuccess();
      }, 5000);
    } catch (err) {}
    // Perform API request to update product -
    reset();
  };

  return (
    <div className="mb-5">
      <Container className="mt-5 shadow-sm">
        {isSuccess && <CustomToast msg={"Customer added successfully!"} />}
        {isError && <CustomToast err={error} msg={error.data.errorMessage} />}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col lg={6} md={6} xs={12}>
              <Input
                label={"Company name"}
                field={"companyName"}
                register={register}
                defaultValue={customer.companyName}
                errors={errors}
              />
              <Input
                label={"Address"}
                field={"address"}
                register={register}
                defaultValue={customer.address}
                errors={errors}
              />
              <Input
                label={"Delivery address"}
                field={"deliveryAddress"}
                register={register}
                defaultValue={customer.deliveryAddress}
                errors={errors}
              />
              <Input
                label={"Phone"}
                field={"phone"}
                register={register}
                defaultValue={customer.phone}
                errors={errors}
              />
            </Col>
            <Col lg={6} md={6} xs={12}>
              <Input
                label={"Email"}
                field={"email"}
                register={register}
                defaultValue={customer.email}
                errors={errors}
              />

              <Input
                label={"Registration no"}
                field={"registrationNo"}
                register={register}
                defaultValue={customer.registrationNo}
                errors={errors}
              />
              <Input
                label={"Last name"}
                field={"lastName"}
                register={register}
                defaultValue={customer.lastName}
                errors={errors}
              />
              <Input
                label={"First name"}
                field={"firstName"}
                register={register}
                defaultValue={customer.firstName}
                errors={errors}
              />
            </Col>
          </Row>
          <Row className="py-2">
            <Col lg={12}>
              <Button
                type="submit"
                variant="success"
                className="w-100"
                disabled={isLoading}
              >
                {isLoading ? "Saving" : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};
